"use client";

import { Switch } from "@nyntax/design-system/components/ui/switch";

import { useFeedback } from "./use-feedback";

/**
 * Settings card with toggles for sound and haptic feedback channels.
 * Renders two Switch rows bound to the FeedbackContext.
 * Each toggle plays a preview sound/haptic when changed.
 */
export function FeedbackSettings() {
  const { sound, haptic, setSound, setHaptic, play } = useFeedback();

  return (
    <div className="flex flex-col gap-4">
      <div className="flex items-center justify-between gap-4">
        <div className="flex flex-col gap-0.5">
          <span className="text-sm font-medium">Sound</span>
          <span className="text-muted-foreground text-xs">
            Play audio feedback for interactions
          </span>
        </div>
        <Switch
          checked={sound}
          onCheckedChange={(checked) => {
            setSound(checked);

            if (checked) {
              play("toggle-on");
            }
          }}
        />
      </div>
      <div className="flex items-center justify-between gap-4">
        <div className="flex flex-col gap-0.5">
          <span className="text-sm font-medium">Haptic</span>
          <span className="text-muted-foreground text-xs">
            Vibration feedback on interactions
          </span>
        </div>
        <Switch
          checked={haptic}
          onCheckedChange={(checked) => {
            setHaptic(checked);

            if (checked) {
              play("toggle-on");
            }
          }}
        />
      </div>
    </div>
  );
}
